<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'
import Tooltip from "@/components/misc/Tooltip.vue"

defineProps<{
  floated?: boolean
}>()

const store = useGlobalsStore()
const { cart_items, ConfigElementsColor } = storeToRefs(store)

function openCart() {
  store.SetAnyState({ target: 'cart_modal', value: true })
}
</script>

<template>
  <Tooltip :text="`(${cart_items.length}) items in your cart`">
    <v-badge class="copier-cart" :content="cart_items.length" :color="ConfigElementsColor">
      <template #default>
        <v-btn size="40" variant="text" icon="mdi-cart-outline" @click="openCart"/>
      </template>
    </v-badge>
  </Tooltip>
</template>

<style>
.copier-cart .v-badge__badge {
  top: -6px
}
</style>
